module.exports = __webpack_public_path__ + "img/wild_2.b552c022.png";